export enum GRAPHQL_CLIENT {
  TOPUP = 'topup',
  CONTENTFUL = 'contentful',
}
